export interface SubscribeFormProps {
  email: string;
  firstName: string;
  subscribeToWineGroup: boolean;
  subscribeToWebshop: boolean;
}

export const subscribe = async (formBody: SubscribeFormProps) => {
  try {
    const formData = new FormData();
    formData.append('email', formBody.email);
    formData.append('firstName', formBody.firstName);
    formData.append('subscribeToWineGroup', formBody.subscribeToWineGroup.toString());
    formData.append('subscribeToWebshop', formBody.subscribeToWebshop.toString());

    const response = await fetch(`/Home/AddSubscriberToAudienceList`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    });

    return await response.json();
  } catch (error) {
    throw new Error(error);
  }
};
